import { WaitlistService } from "@/services/waitlistService";

export const waitlistStore = {
  namespaced: true,
  state: {
    isWaitlistActive: false,
    waitlistData:
      JSON.parse(localStorage.getItem("waitlistData") ?? "{}") || {},
    childId: "",
    waitlistTicketId: null,
    headerData: {},
    footerData: {},
    childcareRequests: [],
    waitlistOptions: []
  },

  getters: {
    isWaitlistActive(state: any) {
      return state.isWaitlistActive;
    },
    headerData(state: any) {
      return state.headerData;
    },
    footerData(state: any) {
      return state.footerData;
    },
    waitlistData(state: any) {
      return state.waitlistData;
    }
  },

  mutations: {
    setHeaderData(state: any, data: any) {
      state.headerData = data;
    },
    setFooterData(state: any, data: any) {
      state.footerData = data;
    },
    setChildId(state: any, id: string) {
      state.childId = id;
    },
    setWaitlistTicketId(state: any, id: number) {
      state.waitlistTicketId = id;
    },
    toggleWaitlist(state: any) {
      state.isWaitlistActive = !state.isWaitlistActive;
    },
    openWaitlist(state: any) {
      state.isWaitlistActive = true;
    },
    setProviderTypes(state: any, { providerTypes, distance }: { providerTypes: number[]; distance: number }) {
      state.waitlistData = {
        ...state.waitlistData,
        Distance: distance,
        ProviderTypes: providerTypes
      };
      localStorage.setItem("waitlistData", JSON.stringify(state.waitlistData));
    },
    setChildcareTypes(state: any, childcareTypes: number[]) {
      state.waitlistData = {
        ...state.waitlistData,
        ChildcareTypes: childcareTypes
      };
      localStorage.setItem("waitlistData", JSON.stringify(state.waitlistData));
    },
    setRequestedStartDate(state: any, startDate: string) {
      state.waitlistData = {
        ...state.waitlistData,
        RequestedStartDate: startDate
      };
      localStorage.setItem("waitlistData", JSON.stringify(state.waitlistData));
    },
    setSchoolPlanList(state: any, schoolList: number[]) {
      state.waitlistData = {
        ...state.waitlistData,
        SchoolPlans: schoolList
      };
      localStorage.setItem("waitlistData", JSON.stringify(state.waitlistData));
    },
    setScheduleAvailability(state: any, scheduleAvailability: any) {
      state.waitlistData = {
        ...state.waitlistData,
        ScheduleAvailability: scheduleAvailability
      };
      localStorage.setItem("waitlistData", JSON.stringify(state.waitlistData));
    },
    setPaymentOptions(state: any, payload: { componentId: string; paymentOptions: number[] }) {
      const { componentId, paymentOptions } = payload;

      state.waitlistData = {
        ...state.waitlistData,
        PaymentOptions: paymentOptions
      };

      localStorage.setItem("waitlistData", JSON.stringify(state.waitlistData));
    },
    setWaitlistOptions(state: any, options: any[]) {
      state.waitlistOptions = options;
    },
  },

  actions: {
    updateHeaderData({ commit }: any, data: any) {
      commit("setHeaderData", data);
    },
    updateFooterData({ commit }: any, data: any) {
      commit("setFooterData", data);
    },
    getWaitlistSchoolPlans() {
      return new WaitlistService().getAllSchoolPlans().then(
        succsess => {
          return Promise.resolve(succsess.data);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    getWaitlistSchoolPlanItem(_: any, id: number) {
      return new WaitlistService().getSchoolPlanById(id).then(
        success => {
          return Promise.resolve(success);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    getWaitlistDailyPayment() {
      return new WaitlistService().getDailyPayment().then(
        success => {
          return Promise.resolve(success);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    getWaitlistHourlyPayment() {
      return new WaitlistService().getHourlyPayment().then(
        success => {
          return Promise.resolve(success);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    getChildcareTypesItems() {
      return new WaitlistService().getChildcareTypes().then(
        success => {
          return Promise.resolve(success.data);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    getProviderTypesItems(_: any, waitingListTicketId: number) {
      return new WaitlistService().getProviderTypes(waitingListTicketId).then(
        success => {
          return Promise.resolve(success.data);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    async getWaitlistFilters({ state }: any) {
      if (validateWaitlistData(state.waitlistData)) {
        return await WaitlistService.getWaitlistFilters(state.waitlistData);
      }

      return {}
    },
    getCurrentProvider(state: any, { childId, childcareProviderId }: {childId: string, childcareProviderId: string}) {
      return new WaitlistService().getCurrentProvider(childId, childcareProviderId).then(success => {
        return Promise.resolve(success.data)
      }, error => {
        return Promise.reject(error)
      })
    },
    async getFilteredProvidersList(state: any, id: string) { 
      const result = await new WaitlistService().getFilteredProviders(id)
      return result?.data
    },
    async postWaitlistData({ state }: any, childId: string) {
      const waitlistData = state.waitlistData;

      try {
        const response = await new WaitlistService().postWaitlistData(childId, waitlistData);

        return Promise.resolve(response.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async clearWaitlistData({ state }: any) {
      state.waitlistData = { };
      localStorage.removeItem("waitlistData");
    },

    async putWaitlistData({ state }: any, { childId, waitlistTicketId }: {childId: string, waitlistTicketId: number} ) {
      const waitlistData = state.waitlistData;

      if (!childId) {
        return Promise.reject(
          new Error("Child ID is missing. Waitlist ticket cannot be updated.")
        );
      }

      if (!waitlistTicketId) {
        return Promise.reject(
          new Error(
            "Waitlist ticket ID is missing. Waitlist ticket cannot be updated."
          )
        );
      }

      try {
        const response = await new WaitlistService().putWaitlistData(childId, waitlistTicketId, waitlistData);

        return Promise.resolve(response.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },

    async getWaitlistPriorities({ commit }: any, userId: string) {
      try {
        const waitlistOptions = await new WaitlistService().getWaitlistPriorities(userId);
        return Promise.resolve(waitlistOptions.data.items);
      } catch (error) {
        return Promise.reject(error);
      }
    },

    async postWaitlistPriorities({ state }: any, { waitlistTicketId, priorities, childcareProviderId }: { waitlistTicketId: number; priorities: number[], childcareProviderId: string }) {
      const response = await new WaitlistService().postWaitlistPriorities(childcareProviderId, waitlistTicketId, priorities);
      return Promise.resolve(response);
    },

    async getChildcareRequests({ state }: any, userId: string) {
      try {
        const response = await new WaitlistService().getWaitlistRequests(userId);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },

    async deleteChildcareRequest({ state }: any, { providerId, waitlistTicketId, body }: { providerId: string; waitlistTicketId: number, body: any }) {
      try {
        const response = await new WaitlistService().deleteWaitlistRequest(providerId, waitlistTicketId, body);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  }
};

export default waitlistStore;

const validateWaitlistData = (waitlistData: any): boolean => {
  return waitlistData
    && waitlistData.ProviderTypes?.length >= 0 
    && waitlistData.ChildcareTypes?.length >= 0 
    && waitlistData.SchoolPlans?.length >= 0 
    && waitlistData.PaymentOptions?.length >= 0 
}